/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'crop': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M81.1 92.8H10.7V69.4h58.6V10.7h23.5v70.4c0 6.5-5.2 11.7-11.7 11.7zM92.8 245.3H69.4v-58.6H10.7v-23.5h70.4c6.5 0 11.7 5.3 11.7 11.7v70.4zM186.6 245.3h-23.5v-70.4c0-6.5 5.3-11.7 11.7-11.7h70.4v23.5h-58.6v58.6zM245.3 92.8h-70.4c-6.5 0-11.7-5.3-11.7-11.7V10.7h23.5v58.6h58.6v23.5z"/>'
  }
})
